import { useState } from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { Autocomplete } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";

import {
  LOCATION_API_01,
  USERS_EMAIL_SETUP_API_03,
  USERS_EMAIL_SETUP_API_01,
  SHOP_API_01,
  USERS_EMAIL_SETUP_API_02,
} from "../../api/ApiModel";

import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
function AddEmailsetup() {
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [data, setData] = useState(null);
  const [datashop, setDatashop] = useState(null);
  const [selectedLOC, setSelectedLOC] = useState("");
  const [selectedSHOP, setSelectedSHOP] = useState("");
  const [selectedLocCode, setSelectedLocCode] = useState("");
  const [selectedrestcode, setSelectedrestcode] = useState("");
  const [locationdata, setLocationData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [inputUserName, setInputUserName] = useState("");
  const [dataloc, setDataloc] = useState(null);
  const [dataemailaction, setDataemailaction] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [dataemail, setDataemail] = useState([]);
  const { state } = useLocation();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [filePath, setFilePath] = useState("");
  const [croppedImg, setCroppedImg] = useState("");
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const isEdit = location.state?.actionText === "Edit";
  const [fileName, setFileName] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    interval: "",
    subject: "",
    bodytext: "",
    webcontent: "",
    footercontent: "",
    docpath: "",
    frommail: "",
    sender: "",
  });
  const [imageSrc, setImageSrc] = useState(
    "https://st3.depositphotos.com/3326513/19442/v/450/depositphotos_194428038-stock-illustration-black-linear-photo-camera-logo.jpg" // Default image URL
  );
  const  selectedItem  = location.state?.selectedItem;


  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        interval: String(selectedItem.INTERVAL),
        subject: selectedItem.SUBJECT,
        bodytext: selectedItem.BODYTEXT,
        webcontent: selectedItem.WEBCONTENT,
        footercontent: selectedItem.FOOTERCONTENT,
        docpath: selectedItem.DOCPATH,
        frommail: selectedItem.FROMMAIL,
        sender: selectedItem.SENDER,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem && selectedItem.IMAGEPATH) {
      setImageSrc(selectedItem.IMAGEPATH);
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchLocationData();
  }, []);

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERNAME, GROUPCODE } = SYS_USER.USER_PARAM || {};

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Only number validation for 'interval'
    if (name === "interval" && value && !/^\d*$/.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        interval: "Only numbers are allowed",
      }));
      return;
    }

    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setInputUserName(value);

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    })); // Clear field-specific error on input
  };

  const handleClearClick = () => {
    //clear text filed function goes here
    setSelectedItemDetails({
      mailaction: "",
      interval: "",
      subject: "",
      bodytext: "",
      webcontent: "",
      footercontent: "",
      docpath: "",
      frommail: "",
      sender: "",
    });
  };

    const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };

  const handleConfirmClick = async () => {
    const {
      interval,
      subject,
      bodytext,
      webcontent,
      footercontent,
      frommail,
      sender,
    } = selectedItemDetails;

    const requiredFields = [
      { name: "interval", value: interval, label: "Interval" },
      { name: "subject", value: subject, label: "Subject" },
      { name: "bodytext", value: bodytext, label: "Body Text" },
      { name: "webcontent", value: webcontent, label: "Web Content" },
      { name: "footercontent", value: footercontent, label: "Footer Content" },
      // { name: "docpath", value: docpath, label: "Document Path" },
      { name: "frommail", value: frommail, label: "From Mail" },
      { name: "sender", value: sender, label: "Sender" },

      // Add more fields as needed
      // { name: "username", value: username, label: "Username" },
    ];

    // Required field validation
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError);
      setSnackbarMessage(`Required fields.`);
      setOpenErrorSnackbar(true);
      return;
    }

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!validateEmail(frommail)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        EMAIL: "Please enter a valid email address.",
      }));
      setSnackbarMessage("Please enter a valid email address.");
      setOpenErrorSnackbar(true);
      return; // Stop further execution if the email is invalid
    }



    // if (dataloc) {
    //   const isDuplicate = dataloc.some((item) => {
    //     if (
    //       item.USERNAME != selectedItemDetails.USERNAME &&
    //       item.USERNAME === USERNAME
    //     ) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });

    //   if (isDuplicate) {
    //     setSnackbarMessage("User name already exists."); // Show snackbar if duplicate found
    //     setOpenErrorSnackbar(true);
    //     return;
    //   }
    // }
    const staticValues = {
      COMPCODE: COMPCODE,
      LOCCODE: selectedItem.LOCCODE,
      RESTCODE: String(selectedItem.RESTCODE),
      MAILACTIONCODE: parseInt(selectedItem.MAILACTIONCODE),
      SENDMAILCODE: 0,
      MAILACTION: "",
      DOCPATH:"",
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      const jsonString = JSON.stringify(payload);
      console.log("Payload for API call:", jsonString);
      const responseData = await externalpostApi(
        USERS_EMAIL_SETUP_API_03,
        payload
      );

      //make below 
  if (responseData.message === "Email setup created successfully.") {
        setTimeout(() => {
          gotToPage();
        }, 2000);
      }
      setSnackbarMessage("Email Setup Successfully!");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SHOP_API_01, "get", {
          COMPCODE: COMPCODE,
          GROUPCODE: GROUPCODE,
          USERNAME: USERNAME,
          // CATTYPE: "R",
          STS: CON_STATUS_ACTIVE,
        });
        setDatashop(result);

        console.log("result", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, []);

  // Fetch locations from API
  const fetchLocationData = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE: COMPCODE,
        STS: CON_STATUS_ACTIVE,
        GROUPCODE: GROUPCODE,
        USERNAME: USERNAME,
      };

      const response = await externalgetApi(LOCATION_API_01, "get", params);
      if (Array.isArray(response)) {
        setLocationData(response);
        // Ensure response is an array
      } else {
        setError("Invalid data format from API.");
        setLocationData([]); // Fallback to an empty array
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setError("Failed to fetch locations.");
      setLocationData([]); // Fallback to an empty array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result);
        console.log("Filtered Locations:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
      }
    };

    fetchLocations();
  }, []);

  const handleSelectionloc = (newValue) => {
    if (newValue && newValue.LOCCODE) {
      setSelectedLOC(newValue);
      setSelectedLocCode(newValue.LOCCODE);
    } else {
      setSelectedLocCode("");
      setSelectedLOC(null);
    }
  };

  // 1. Add this state at the top with your other useState hooks
  const [selectedBusinessTypeCode, setSelectedBusinessTypeCode] = useState("");
  const [selectedModuleCode, setselectedModuleCode] = useState("");

  useEffect(() => {
    setselectedModuleCode(selectedBusinessTypeCode === "R" ? "3" : "7");
  }, [selectedBusinessTypeCode]);

  // 2. Update handleSelectionshop to set the business type code
  const handleSelectionshop = (newValue) => {
    if (newValue && newValue.RESTCODE) {
      setSelectedSHOP(newValue);
      setSelectedrestcode(newValue.RESTCODE);
      setSelectedBusinessTypeCode(newValue.BUSINESSTYPECODE || "");
    } else {
      setSelectedSHOP("");
      setSelectedrestcode(null);
      setSelectedBusinessTypeCode("");
    }
  };

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
      setSelectedLocCode(dataloc[0].LOCCODE); // Set the first item's LOCCODE as the default
    }
  }, [dataloc, selectedLOC]);

  useEffect(() => {
    if (Array.isArray(datashop) && datashop.length > 0 && !selectedSHOP) {
      setSelectedSHOP(datashop[0]); // Set the first shop as default
      setSelectedrestcode(datashop[0].RESTCODE); // Set the first shop's RESTCODE as default
    }
  }, [datashop, selectedSHOP]);

  const gotToPage = () => {
    navigate("/Vemailsetup");
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Email Setup</Link>
                <Link underline="none">Email Setup</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? " Email Setup" : " Email Setup" }}
        />

        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Interval <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="interval"
              value={selectedItemDetails.interval}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.interval)}
              helperText={errors.interval}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  From Mail <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="frommail"
              value={selectedItem.frommail || selectedItemDetails.frommail}
              onChange={handleInputEmailValidation}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.frommail)}
              helperText={errors.frommail}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Sender Name <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="sender"
              value={selectedItemDetails.sender}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.sender)}
              helperText={errors.sender}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Subject <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              multiline
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="subject"
              value={selectedItemDetails.subject}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.subject)}
              helperText={errors.subject}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Body Text <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              name="bodytext"
              size="small"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              autoComplete="off"
              value={selectedItemDetails.bodytext}
              onChange={handleInputChange}
              error={Boolean(errors.bodytext)}
              helperText={errors.bodytext}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Web Content<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="webcontent"
              value={selectedItemDetails.webcontent}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.webcontent)}
              helperText={errors.webcontent}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Footer Content <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              autoComplete="off"
              name="footercontent"
              value={selectedItemDetails.footercontent}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.footercontent)}
              helperText={errors.footercontent}
            />
          </Grid>

          {/* <Grid item lg={6} md={6} xs={12} sm={12}>
        <Box>
                 <Upload
  MAX_FILESIZE={5 * 1024 * 1024}
  onFileSelect={handleFileSelect}
  setSnackbarMessage={setAlertMessage}
  setOpenErrorSnackbar={setAlertOpen}
  setFilePath={setFilePath}
  fileName={fileName}
  setFileName={setFileName}
 
/>
                 
                </Box>
                </Grid> */}
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
            id="btnclr"
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
            id="btnconfirm"
          >
            {"Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default AddEmailsetup;
